import {
  LOGIN,
  VERIFY_OTP,
  RESEND_OTP,
  VERIFY_2FA,
  REQUEST_2FA,
} from '@/constants/path'
import { api as $axios } from '@/helpers/interceptors'
import router from '@/router'
import ROUTE_ENUM from '@/enums/route.enum'
import { ROLES } from '@/enums/other.enum'

const state = () => ({
  data: [],
  isLoggedIn: false,
  accessToken: '',
  isError: false,
  isLoading: false,
  roles: [],
  requires2FA: false,
  userPhoneFor2FA: '',
})

// getters
const getters = {
  token: (state) => {
    return state.accessToken
      ? state.accessToken
      : localStorage.getItem('token') ?? ''
  },

  isSamsung: (state) => {
    return state.roles.includes(ROLES.SAMSUNG)
  },
}

// actions
const actions = {
  /**
   * Login with emp_code / pass
   */
  async login({ commit }, { emp_code, pass }) {
    try {
      commit('SET_LOADING', true)

      let bodyFormData = new FormData()
      bodyFormData.append('emp_code', emp_code)
      bodyFormData.append('pass', pass)
      const res = await $axios(LOGIN, 'post', bodyFormData)
      const { token, role } = res?.data?.data
      if (token) {
        commit('SET_ACCESS_TOKEN', token)
        commit('SET_ROLES', role)
        localStorage.setItem('token', token)
        localStorage.setItem('u', emp_code)
        localStorage.setItem(
          'roles',
          role && role.length
            ? JSON.stringify(role)
            : JSON.stringify([]),
        )
        // dispatch('me/setData', res?.data?.data?.user_profile, {
        //   root: true,
        // })
        if (role.includes(ROLES.SAMSUNG)) {
          router.push({
            name: ROUTE_ENUM.ORDER_HISTORY_SAMSUNG.name,
          })
        } else {
          router.push({
            name: ROUTE_ENUM.ORDER.name,
          })
        }
        commit('SET_LOGIN', true)
        commit('SET_LOADING', false)
        return { error: null }
      }
      return { error: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง' }
    } catch (error) {
      commit('SET_ACCESS_TOKEN', null)
      commit('SET_ROLES', [])
      commit('SET_LOGIN', false)
      commit('SET_LOADING', false)
      return { error: error?.response?.data?.error }
    }
  },
  async logout({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ACCESS_TOKEN', null)
      commit('SET_ROLES', [])
      localStorage.clear()
      commit('SET_LOGIN', false)
      commit('SET_LOADING', false)
      router.push({ name: 'Login' })
    } catch (error) {
      commit('SET_ACCESS_TOKEN', null)
      commit('SET_ROLES', [])
      commit('SET_LOGIN', false)
      commit('SET_LOADING', false)
      throw error
    }
  },

  /**
   * Verify OTP code
   */
  async verifyOTPAction({ commit }, { phone, otp }) {
    try {
      commit('SET_LOADING', true)
      const res = await $axios(VERIFY_OTP, 'post', {
        phone,
        otp,
      })

      const { token, role } = res?.data?.data
      if (token) {
        commit('SET_ACCESS_TOKEN', token)
        commit('SET_ROLES', role)
        localStorage.setItem('token', token)
        localStorage.setItem(
          'roles',
          role && role.length
            ? JSON.stringify(role)
            : JSON.stringify([]),
        )
        commit('SET_LOGIN', true)
      }

      commit('SET_LOADING', false)
      return res
    } catch (error) {
      commit('SET_LOADING', false)
      throw error
    }
  },

  /**
   * Resend OTP code
   */
  async resendOTPAction(_context, { phone }) {
    const res = await $axios(RESEND_OTP, 'post', {
      phone,
    })

    return res
  },

  /**
   * Verify 2FA OTP code
   */
  async verify2FAAction({ commit }, { phone, otp }) {
    try {
      commit('SET_LOADING', true)
      const res = await $axios(VERIFY_2FA, 'post', {
        phone,
        otp,
      })

      const token = res?.data?.data?.token
      if (token) {
        commit('SET_ACCESS_TOKEN', token)
        localStorage.setItem('token', token)
      }

      commit('SET_REQUIRES_2FA', false)
      commit('SET_USER_PHONE_FOR_2FA', '')
      commit('SET_LOADING', false)
      return res
    } catch (error) {
      commit('SET_LOADING', false)
      if (error.response?.status === 401) {
        commit('SET_ACCESS_TOKEN', null)
        commit('SET_REQUIRES_2FA', false)
        commit('SET_USER_PHONE_FOR_2FA', '')
        localStorage.clear()
        router.push({ name: 'Login' })
      }
      throw error
    }
  },

  /**
   * Request 2FA OTP code
   */
  async request2FAAction(_context, { phone }) {
    const res = await $axios(REQUEST_2FA, 'post', {
      phone,
    })

    return res
  },
}

// mutations
const mutations = {
  SET_LOADING(state, payload = false) {
    state.isLoading = payload
  },
  SET_LOGIN(state, payload = false) {
    state.isLoggedIn = payload
  },
  SET_ACCESS_TOKEN(state, payload) {
    state.accessToken = payload
  },
  SET_ROLES(state, payload) {
    state.roles = payload
  },
  SET_REQUIRES_2FA(state, payload) {
    state.requires2FA = payload
  },
  SET_USER_PHONE_FOR_2FA(state, payload) {
    state.userPhoneFor2FA = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
